'use strict';

require('../../styles/templates/product.bumpers-pdp.scss');

require('../components/related-products');

require('../components/product-tabs');

require('../components/product-gallery');

require('../components/product-details');

require('../components/product-byb-options');

require('../components/product-byb-added-cart');

require('../components/product-mmy');